import type React from "react";

import { useAppContext } from "../../contexts/AppContext";
import { useTemplateContext } from "../../contexts/TemplateContext";
import { CaptchaStatusBar } from "../Captcha/CaptchaStatusBar";
import { MobileTemplateButtons } from "../Templating/MobileTemplateButtons";
import { CanvasMeta } from "./CanvasMeta";
import { OverlaySwitcher } from "./OverlaySwitcher";
import { Palette } from "./Palette";
import { UndoButton } from "./UndoButton";

/**
 * Wrapper for everything aligned at the bottom of the screen
 */
export const ToolbarWrapper = ({
  ...props
}: React.HTMLProps<HTMLDivElement>) => {
  const { config } = useAppContext();
  const { showMobileTools } = useTemplateContext();

  if (!config) return <></>;

  return (
    <div id="toolbar" {...props}>
      <CanvasMeta />
      <OverlaySwitcher />
      <UndoButton />
      <CaptchaStatusBar />
      {showMobileTools && <MobileTemplateButtons />}

      <Palette />
    </div>
  );
};
